<template>
  <el-row class="page" :gutter="30">
    <el-col :span="19">
      <el-row class="total_order" :gutter="20">
        <el-col :span="6">
          <tag-chart :order-quality="totalOrder.daily[0]" title="本日订单"></tag-chart>
        </el-col>
        <el-col :span="6">
          <tag-chart :order-quality="totalOrder.weekly[0]" title="本周订单"></tag-chart>
        </el-col>
        <el-col :span="6">
          <tag-chart :order-quality="totalOrder.monthly[0]" title="本月订单"></tag-chart>
        </el-col>
        <el-col :span="6">
          <tag-chart :order-quality="totalOrder.yearly[0]" title="本年订单"></tag-chart>
        </el-col>
      </el-row>
      <el-row class="feed_back" :gutter="20">
        <el-col :span="6">
          <div class="board">
            <div class="title">本日好评率</div>
            <pie-chart titleText="本日好评率" :series-data="positiveFeedbackRate.daily"></pie-chart>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="board">
            <div class="title">本周好评率</div>
            <pie-chart titleText="本周好评率" :series-data="positiveFeedbackRate.weekly"></pie-chart>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="board">
            <div class="title">本月好评率</div>
            <pie-chart titleText="本月好评率" :series-data="positiveFeedbackRate.monthly"></pie-chart>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="board">
            <div class="title">本年好评率</div>
            <pie-chart titleText="本年好评率" :series-data="positiveFeedbackRate.yearly"></pie-chart>
          </div>
        </el-col>
      </el-row>
      <el-row class="ontime_rate" :gutter="20">
        <el-col :span="6">
          <div class="board">
            <div class="title">本日准时率</div>
            <dash-board title-text="本日准时率"
                        v-if="onTimeRate.daily[1] !== 0"
                        :series-data="(onTimeRate.daily[0] / onTimeRate.daily[1]).toFixed(2) * 100"
            >
            </dash-board>
            <dash-board v-else :series-data="0" title-text="本日准时率"></dash-board>
            <div class="content">
              <span
                  :style="{color: getColor((onTimeRate.daily[0] / onTimeRate.daily[1]).toFixed(2) * 100)}"
              >{{ onTimeRate.daily[0] }}</span>
              <span>{{ '/' + onTimeRate.daily[1] }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="board">
            <div class="title">本周准时率</div>
            <dash-board title-text="本周准时率"
                        v-if="onTimeRate.weekly[1] !== 0"
                        :series-data="(onTimeRate.weekly[0] / onTimeRate.weekly[1]).toFixed(2) * 100"
            >
            </dash-board>
            <dash-board v-else :series-data="0" title-text="本周准时率"></dash-board>
            <div class="content">
              <span :style="{color: getColor((onTimeRate.weekly[0] / onTimeRate.weekly[1]).toFixed(2) * 100)}"
              >{{onTimeRate.weekly[0]}}</span>
              <span>{{'/' + onTimeRate.weekly[1]}}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="board">
            <div class="title">本月准时率</div>
            <dash-board title-text="本月准时率"
                        v-if="onTimeRate.monthly[1] !== 0"
                        :series-data="(onTimeRate.monthly[0] / onTimeRate.monthly[1]).toFixed(2) * 100"
            >
            </dash-board>
            <dash-board v-else :series-data="0" title-text="本月准时率"></dash-board>
            <div class="content">
              <span :style="{color: getColor((onTimeRate.monthly[0] / onTimeRate.monthly[1]).toFixed(2) * 100)}"
              >{{onTimeRate.monthly[0]}}</span>
              <span>{{'/' + onTimeRate.monthly[1]}}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="board">
            <div class="title">本年准时率</div>
            <dash-board title-text="本年准时率"
                        v-if="onTimeRate.yearly[1] !== 0"
                        :series-data="(onTimeRate.yearly[0] / onTimeRate.yearly[1]).toFixed(2) * 100"
            >
            </dash-board>
            <dash-board v-else :series-data="0" title-text="本年准时率"></dash-board>
            <div class="content">
              <span :style="{color: getColor((onTimeRate.yearly[0] / onTimeRate.yearly[1]).toFixed(2) * 100)}"
              >{{onTimeRate.yearly[0]}}</span>
              <span>{{'/' + onTimeRate.yearly[1]}}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="5" class="medical_certificate">
      <div class="title">今日入院人员健康证明</div>
      <el-row class="crew_card" v-for="item in dailyData" :key="item.id">
        <el-col class="head">
          <div class="face">
            <el-avatar icon="el-icon-user-solid" size="medium"></el-avatar>
          </div>
          <div class="name">{{ item.name }}</div>
        </el-col>
        <el-row :gutter="10">
          <el-col class="photo" :span="8">
            <el-image :src="item.url.health_code" fit="fill" :preview-src-list="[item.url.health_code]">
              <div slot="error" class="image-slot">
                <span class="tip">未上传</span>
              </div>
            </el-image>
          </el-col>
          <el-col class="photo" :span="8">
            <el-image :src="item.url.trip_code" fit="fill" :preview-src-list="[item.url.trip_code]">
              <div slot="error" class="image-slot">
                <span class="tip">未上传</span>
              </div>
            </el-image>
          </el-col>
          <el-col class="photo" :span="8">
            <el-image :src="item.url.nucleic_acid_report" fit="fill" :preview-src-list="[item.url.nucleic_acid_report]">
              <div slot="error" class="image-slot">
                <span class="tip">未上传</span>
              </div>
            </el-image>
          </el-col>
        </el-row>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import pieChart from '../ChartComponents/PieChart'
import tagChart from '../ChartComponents/TagChart'
import dashBoard from '../ChartComponents/DashBoard'
import GLOBAL from '@/utils/global.js'
  export default {
    name: "FrontPage",
    components: {
      pieChart,
      tagChart,
      dashBoard
    },
    data() {
      return {
        GLOBAL,
        positiveFeedbackRate: {
          daily: [],
          weekly: [],
          monthly: [],
          yearly: [],
        },
        totalOrder: {
          daily: [],
          weekly: [],
          monthly: [],
          yearly: [],
        },
        onTimeRate: {
          daily: [],
          weekly: [],
          monthly: [],
          yearly: [],
        },
        dailyData: [],
      };
    },
    created() {
      this.getPositiveFeedbackRate();
      this.getTotalOrder();
      this.getOnTimeRate();
      this.getDaily();
    },
    methods: {
      getPositiveFeedbackRate(){
        this.$store.dispatch('Statistics/getPositiveFeedbackRate')
        .then((res) => {
          if(!this.$store.state.visitorMode && GLOBAL.debugMode){
            console.log(res);
          }
          this.positiveFeedbackRate = { ...res.data.data};
        })
        .catch((res) => {
          if(!this.$store.state.visitorMode && GLOBAL.debugMode){
            console.log(res);
          }
        })
      },
      getTotalOrder(){
        this.$store.dispatch('Statistics/getTotalOrder')
            .then((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
              this.totalOrder = {...res.data.data}
            })
            .catch((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
            })
      },
      getOnTimeRate() {
        this.$store.dispatch('Statistics/getOnTimeRate')
            .then((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
              this.onTimeRate = {...res.data.data};
            })
            .catch((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
            })
      },
      getColor(val){
        if(val < 33){
          return '#F56C6C';
        }else if(val < 66){
          return '#409EFF';
        }else{
          return '#67C23A';
        }
      },
      getDaily(){
        this.$store.dispatch('Statistics/getDaily')
        .then((res) => {
          if(!this.$store.state.visitorMode && GLOBAL.debugMode){
            console.log(res);
          }
          this.dailyData = res.data.data;
        })
        .catch((res) => {
          if(!this.$store.state.visitorMode && GLOBAL.debugMode){
            console.log(res);
          }
        })
      }
    },
  };
</script>

<style scoped>
.page{
  background-color: rgb(233, 238, 243);
  padding: 1rem;
}
.page .total_order{
  margin-bottom: 1rem;
}
.page .total_order .tag_board{
  /*margin-right: 0.5rem;*/
}
.page .total_order .el-col:last-child  .tag_board{
  margin-right: 0;
}
.page .feed_back{
  margin-bottom: 1rem;
}
.page .feed_back .board{
  border-radius: 5px;
  background-color: white;
  padding: 1rem;
}
.page .feed_back .el-col:last-child .board{
  margin-right: 0;
}
.page .feed_back .board .title, .page .ontime_rate .board .title{
  text-align: left;
  font-size: 1.2rem;
  font-weight: 700;
}
.page .ontime_rate .board{
  background-color: white;
  border-radius: 5px;
  padding: 1rem;
  position: relative;
}
.page .ontime_rate .el-col:last-child .board{
  margin-right: 0;
}
.page .ontime_rate .board .content{
  position: absolute;
  bottom: 2rem;
  /*bottom: 0;*/
  left: 0;
  text-align: center;
  width: 100%;
  font-size: 1.2rem;
  color: #909399;
  font-weight: 700;
}
/*健康证明*/
.page .medical_certificate{
  background-color: white;
  border-radius: 5px;
  padding: 1rem;
}
.page .medical_certificate .title{
  font-weight: 700;
  font-size: 1.2rem;
}
.page .medical_certificate .crew_card{
  margin-top: 1rem;
}
.page .medical_certificate .crew_card .head{
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}
.page .medical_certificate .crew_card .head .face{
  width: 30px;
  height: 30px;
  /*border-radius: 50%;*/
  /*background-color: #67C23A;*/
}
.page .medical_certificate .crew_card .head .name{
  margin-left: 1rem;
}
.page .medical_certificate .crew_card .photo{
  height: 50px;
}
.page .medical_certificate .crew_card .photo .el-image{
  height: inherit;
}
.tip{
  color: #8c939d!important;
  font-size: 8px!important;
}
</style>
